export interface UploadProgressItem
{
    id: number;
    name: string;
    progress: number;
    status: 'waiting' | 'sending' | 'processing' | 'success' | 'error';
    error?: string;
}

export function uploadBatchPercent(items: UploadProgressItem[])
{
    if (!items.length) return 0;
    return Math.round(items.reduce((sum, item) => sum + (item.status === 'success' || item.status === 'error' ? 100 : item.progress), 0) / items.length);
}

export const UPLOAD_DISMISS_DURATION = 10000;

export function createUploadDismissTimer(close: () => void, progress: (remaining: number) => void = () => {})
{
    let timer: ReturnType<typeof setTimeout> | null = null;
    let ticker: ReturnType<typeof setInterval> | null = null;
    let remaining = UPLOAD_DISMISS_DURATION;
    let deadline = 0;
    let active = false;
    let paused = false;

    function stop()
    {
        if (timer) clearTimeout(timer);
        if (ticker) clearInterval(ticker);
        timer = null;
        ticker = null;
    }
    function start()
    {
        if (!active || paused) return;
        deadline = Date.now() + remaining;
        progress(remaining);
        ticker = setInterval(() => progress(Math.max(0, deadline - Date.now())), 50);
        timer = setTimeout(() =>
        {
            stop();
            active = false;
            remaining = 0;
            progress(0);
            close();
        }, remaining);
    }
    function setPaused(value: boolean)
    {
        if (paused === value) return;
        if (value && active && timer)
        {
            remaining = Math.max(0, deadline - Date.now());
            stop();
            progress(remaining);
        }
        paused = value;
        if (!paused) start();
    }
    function dispose()
    {
        stop();
        active = false;
    }
    function update(visible: boolean, running: boolean, items: UploadProgressItem[])
    {
        dispose();
        remaining = UPLOAD_DISMISS_DURATION;
        progress(remaining);
        active = visible && !running && items.length > 0 && items.every(item => item.status === 'success');
        start();
    }
    return { update, setPaused, dispose };
}
